import { useCompanyReadDataContext } from '@aibees/elephant/context';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { Tags } from '../tags';
import * as Styled from './styles';
import * as SX from './sx';
import type { ProductServicesTagsProps as Props } from './types';

export const ProductServicesTags = memo(
  ({ className, items, config, limitCount = 5, isDetailPopover }: Props) => {
    const { api } = useCompanyReadDataContext();

    return (
      <Styled.Wrapper
        className={classnames('ProductServicesTags', className)}
        sx={SX.root}
      >
        <Tags
          items={items}
          limit={limitCount}
          config={config}
          icon="product-and-services"
          title={`Product & Services`}
          isDetailPopover={isDetailPopover}
        />
      </Styled.Wrapper>
    );
  }
);

ProductServicesTags.displayName = 'ProductServicesTags';
